import { WorkspaceApiCredentialsRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/api_credentials/')({
  component: WorkspaceApiCredentialsRoute,
});
